export default {"src":"/_next/static/media/good.52b7090e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};